import '../styles/main.scss';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import $ from 'jquery';
import '@fancyapps/fancybox';
import './components/sliders';

$(document).ready(() => {
  $('.js-product-cat a').on('click', function (e) {
    e.preventDefault();
    const id = $(this).attr('href');

    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    $(id).addClass('active');
    $(id).siblings().removeClass('active');
  });

  let lastId;
  const topMenu = $('.header__menu');
  // All list items
  const menuItems = topMenu.find('a');
  // Anchors corresponding to menu items
  const scrollItems = menuItems.map(() => {
    const id = $(this).attr('href');
    if (id !== '#') {
      const item = $(`${id}`);
      if (item.length) {
        return item;
      }
    }
  });
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function (e) {
    const href = $(this).attr('href');
    const offsetTop = href === '#' ? 0 : $(href).offset().top;
    $('html, body').stop().animate({
      scrollTop: offsetTop - 110,
    }, 1000);
    if ($(window).width() < 767) {
      $('.js-mobile-menu-close').trigger('click');
    }
    e.preventDefault();
  });
  // Bind to scroll
  $(window).on('scroll', function () {
    // Get container scroll position
    const fromTop = $(this).scrollTop() + 100;
    // Get id of current scroll item
    let cur = scrollItems.map(() => {
      if ($(this).offset().top < fromTop) {
        return this;
      }
    });
    // Get the id of the current element
    cur = cur[cur.length - 1];
    const id = cur && cur.length ? cur[0].id : '';
    if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      menuItems.removeClass('active');
      $(`[href='#${id}']`).addClass('active');
    }
  });

  $('.js-toggle-menu').on('click', function (e) {
    e.preventDefault();
    if ($(window).width() > 992) {
      $(this).toggleClass('is-active');
      $('.catalog-menu').toggleClass('is-active');
      setTimeout(() => {
        $('.catalog-menu').toggleClass('opened');
      }, 100);
    } else {
      $('.header__menu').toggleClass('open');
      $('body').append("<div class='mobile-menu__overlay'></div>");
      $('.header__menu').append("<button class='js-mobile-menu-close mobile-menu-close'></button>");
    }
  });

  $(document).on('click', '.js-mobile-menu-close', function () {
    $('.header__menu').removeClass('open');
    $('.header__menu__overlay').remove();
    $(this).remove();
  });

  $('body').on('click', '.header__menu__overlay', function () {
    $('.header__menu').removeClass('open');
    $(this).remove();
    $('.js-mobile-menu-close').remove();
  });

  /* Модальные окна */
  $(document).on('click', '.js-modal', function (e) {
    e.preventDefault();
    let modalId;
    if ($(this).attr('data-modal') != undefined) {
      modalId = $(this).attr('data-modal');
    } else {
      modalId = $(this).attr('href');
    }
    $(modalId).addClass('open');
    $('body').append('<div class="modal-overlay"></div>');
    $('html').addClass('lock-screen');
    if ($('.mobile-menu').hasClass('open')) {
      $('.mobile-menu').removeClass('open');
      $('.mobile-menu__overlay').remove();
    }
  });
  $(document).on('click', '.js-modal-close', function (e) {
    e.preventDefault();
    $(this).parents('.modal').removeClass('open');
    $('html').removeClass('lock-screen');
    $('.modal-overlay').remove();
  });
  $(document).keyup((e) => {
    if (e.key === 'Escape') { // escape key maps to keycode '27'
      $('.modal').removeClass('open');
      $('html').removeClass('lock-screen');
      $('.modal-overlay').remove();
    }
  });
  $(document).mouseup((e) => {
    const container = $('.modal');

    if (container.has(e.target).length === 0) {
      $('.modal').removeClass('open');
      $('html').removeClass('lock-screen');
      $('.modal-overlay').remove();
    }
  });
});
